"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventManager = /** @class */ (function () {
    function EventManager() {
        this.all = new Map();
        //   public all() {}
    }
    /**
     * Register an event handler for the given type.
     * @param {string|symbol} type Type of event to listen for, or `'*'` for all events
     * @param {Function} handler Function to call in response to given event
     * @memberOf EventManager
     */
    EventManager.prototype.on = function (type, handler) {
        var handlers = this.all.get(type);
        if (handlers) {
            handlers.push(handler);
        }
        else {
            this.all.set(type, [handler]);
        }
    };
    /**
     * Remove an event handler for the given type.
     * If `handler` is omitted, all handlers of the given type are removed.
     * @param {string|symbol} type Type of event to unregister `handler` from, or `'*'`
     * @param {Function} [handler] Handler function to remove
     * @memberOf EventManager
     */
    EventManager.prototype.off = function (type, handler) {
        var handlers = this.all.get(type);
        if (handlers) {
            if (handler) {
                handlers.splice(handlers.indexOf(handler) >>> 0, 1);
            }
            else {
                this.all.set(type, []);
            }
        }
    };
    /**
     * Invoke all handlers for the given type.
     * If present, `'*'` handlers are invoked after type-matched handlers.
     *
     * Note: Manually firing '*' handlers is not supported.
     *
     * @param {string|symbol} type The event type to invoke
     * @param {Any} [evt] Any value (object is recommended and powerful), passed to each handler
     * @memberOf EventManager
     */
    EventManager.prototype.emit = function (type, evt) {
        var handlers = this.all.get(type);
        if (handlers) {
            ;
            handlers.slice().forEach(function (handler) {
                handler(evt);
            });
        }
        handlers = this.all.get("*");
        if (handlers) {
            ;
            handlers.slice().forEach(function (handler) {
                handler(type, evt);
            });
        }
    };
    return EventManager;
}());
exports.default = EventManager;
//# sourceMappingURL=event-manager.js.map